'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return {
        format: true,
        chunk: 10,
        chunksNavigation: 'fixed',
        edgeNavigation: false,
        theme: 'bootstrap3',
        texts: {
            count: 'Showing {from} to {to} of {count} records|{count} records|One record',
            first: 'First',
            last: 'Last'
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-pagination-2/compiled/config.js
// module id = 1549
// module chunks = 64